import { Component } from "react";
import "../css/Navbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { withRouter } from "../hock/withRouter";
import Swal from "sweetalert2";

class Navbar extends Component {
  apiUrl = process.env.REACT_APP_API_URL;
  name = "dongeun-jwt";

  api = {
    logout: this.apiUrl + "/logout",
    jvm: this.apiUrl + "/jvmConfirm",
  };

  state = {
    toggleActive: false,
  };

  handle = {
    memory: async () => {
      const response = await fetch(this.api.jvm, {
        method: "GET",
        credentials: "include", // 이 옵션을 추가
      });
      const data = await response.json();
      Swal.fire(data.data[0].UsedHeapMemory + "mb");
    },
    toggleClick: () => {
      this.setState({
        toggleActive: !this.state.toggleActive,
      });
    },
    logout: async () => {
      const response = await fetch(this.api.logout, {
        method: "GET",
        credentials: "include", // 이 옵션을 추가
      });

      const data = await response.json();

      if (data.code === "200") {
        this.props.navigate("/", { replace: true });
      }
    },
  };

  render() {
    return (
      <div style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
        <nav className="navbar">
          <div className="navbar__logo">
            <i className="fab fa-accusoft"></i>
            <Link to="/main">동언테크</Link>
          </div>

          <ul
            className={`navbar__menu ${
              this.state.toggleActive ? "active" : ""
            }`}
          >
            {/* <li>
              <Link to="/main">메인화면</Link>
            </li> */}
            <li>
              <Link onClick={this.handle.toggleClick} to="/equipment">
                설비 가동 및 비가동 현황
              </Link>
            </li>
            <li>
              <Link onClick={this.handle.memory}>메모리 확인</Link>
            </li>
            {/* <li>
              <Link to="/main">메뉴얼</Link>
            </li> */}
            {this.props.auth === true && (
              <li>
                <Link onClick={this.handle.logout}>로그아웃</Link>
              </li>
            )}
          </ul>

          <Link onClick={this.handle.toggleClick} className="navbar__toggleBtn">
            <FontAwesomeIcon icon={faBars} />
          </Link>
        </nav>
      </div>
    );
  }
}

export default withRouter(Navbar);
